import React, { useState, useEffect, useRef } from 'react';
import './TestimonialCarousel.css';
import { Link } from 'react-router-dom';


const TestimonialCarousel = () => {
  const carouselRef = useRef(null);
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  useEffect(() => {
    const carousel = carouselRef.current;

    const handleMouseDown = (e) => {
      setIsMouseDown(true);
      setStartX(e.pageX - carousel.offsetLeft);
      setScrollLeft(carousel.scrollLeft);
    };

    const handleMouseLeave = () => {
      setIsMouseDown(false);
    };

    const handleMouseUp = () => {
      setIsMouseDown(false);
    };

    const handleMouseMove = (e) => {
      if (!isMouseDown) return;
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - startX) * 3; 
      carousel.scrollLeft = scrollLeft - walk;
    };

    carousel.addEventListener('mousedown', handleMouseDown);
    carousel.addEventListener('mouseleave', handleMouseLeave);
    carousel.addEventListener('mouseup', handleMouseUp);
    carousel.addEventListener('mousemove', handleMouseMove);

    return () => {
      carousel.removeEventListener('mousedown', handleMouseDown);
      carousel.removeEventListener('mouseleave', handleMouseLeave);
      carousel.removeEventListener('mouseup', handleMouseUp);
      carousel.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isMouseDown, startX, scrollLeft]);

  return (
    <section className="testimonials-section">
      <h2 className="testimonials-title">Наши пользователи</h2>
      <div className="carousel-wrapper">
        <div className="carousel" ref={carouselRef}>
          <div className="carousel-item">
            <p>"Платформа PAI – это отличный способ изучения программирования через практику. Интерфейс интуитивно понятен, а задания всегда актуальны и интересны."</p>
            <p><strong>Полина Жужкова</strong><br />QA @Yandex</p>
          </div>
          <div className="carousel-item">
            <p>"С помощью PAI обучение программированию стало не только полезным, но и увлекательным. Задания разнообразны, а поддержка сообщества всегда на высоте."</p>
            <p><strong>Влад Синицын</strong><br />Студент @HSE</p>
          </div>
          <div className="carousel-item">
            <p>"Платформа PAI помогла мне быстро освоить новые технологии. Каждый урок практический и понятный, что делает обучение максимально эффективным."</p>
            <p><strong>Михаил Лютов</strong><br />Software Engineer @Vk</p>
          </div>
        </div>
      </div>
      <Link to="/courses">
      <button className="cta-button">Присоединяйся к нам сегодня</button>
      </Link>
    </section>
  );
};

export default TestimonialCarousel;
